import React from 'react'

const Banner = ({ tipoProducto }) => {
	return (
		<section className="banner productos d-flex align-items-center" role="banner">

			<div className="container">

				<div className="row">

					<div className="content col-12 ms-3">

						<h1 style={{ fontWeight: "900" }}>
							{tipoProducto?.nombreTipoProducto ?? "Nuestros Productos"}
						</h1>

						<p className="mb-0">
							{tipoProducto ? tipoProducto.descripcion : "Somos Asistente Técnico autorizado de motores WEG de línea estándar y antiexplosivos."}
						</p>

					</div>

				</div>

			</div>

		</section>
	)
}

export default Banner;